import type { ValueObject } from 'jsonld';
import { FindOperator } from '../FindOperator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Or<T extends number | Date | string | boolean | ValueObject>(value: T[]): FindOperator<T[], 'or'> {
  return new FindOperator({
    operator: 'or',
    value
  });
}

